import * as React from 'react';

export const MOBILE_BREAKPOINT = 1024;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(() =>
    typeof window !== 'undefined'
      ? window.innerWidth < MOBILE_BREAKPOINT
      : false
  );

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const update = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    // Listen to both: the media query covers a normal viewport resize, and the
    // `resize` fallback covers cases where the query's `change` event does not
    // fire (some devtools device-mode toggles / programmatic viewport changes),
    // so the layout can never get stuck on the desktop layout at a mobile width.
    mql.addEventListener('change', update);
    window.addEventListener('resize', update);
    update();
    return () => {
      mql.removeEventListener('change', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  return isMobile;
}
